@if (offline) {
    @if (!isEpcotEnabled) {
        <vn-icon name="theme-locked-i" size="13" />
    } @else {
        <span class="locked-icon-alignment"><vn-icon name="theme-locked" size="16" /></span>
    }
} @else {
    @if (optionGroup.balanced && optionGroup.categoryAttribute) {
        <div class="grid-option option-group-attribute">
            <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="optionGroup.categoryAttribute" />
        </div>
    }
    @for (option of options; track option.id) {
        <ms-option
            [decorateAttribute]="decorateAttribute"
            [option]="option"
            [optionGroup]="optionGroup"
            [event]="event"
            [isHighlighted]="shouldHighlight(option)"
            [tracking]="tracking"
            [msAutomation]="getAutomationAttributes(option, optionGroup)"
            [showOptionname]="showOptionname"
            [betDetails]="betDetails"
            [verticalDesignOptions]="verticalDesignOptions"
            [showCenterOptionName]="showOptionNameByOptionTypes(option)"
            [sourceOfPick]="sourceOfPick" />
    }
}
